var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTextItalic extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1444 1.64506C10.0327 1.68598 9.89265 1.78647 9.81131 1.88389C9.70019 2.01702 9.66448 2.11549 9.65337 2.31944C9.64408 2.49008 9.65027 2.5315 9.70202 2.64454C9.82022 2.90274 10.0097 3.05156 10.2748 3.09459C10.3742 3.11072 11.342 3.1196 13.0145 3.1197L15.6005 3.11989L11.1608 11.9992L6.72117 20.8785L4.05081 20.8852L1.38047 20.8919L1.26047 20.947C1.1182 21.0124 0.951282 21.1676 0.884874 21.2961C0.81621 21.429 0.790362 21.6224 0.81933 21.7861C0.864042 22.0386 1.10203 22.3026 1.34363 22.3677C1.40469 22.3841 3.47023 22.3901 7.62355 22.386L13.8125 22.3799L13.9252 22.3244C13.9871 22.2939 14.0825 22.2242 14.1371 22.1696C14.2868 22.0199 14.335 21.9078 14.3475 21.6803C14.3569 21.5096 14.3507 21.4683 14.2989 21.3552C14.1807 21.097 13.9913 20.9482 13.7261 20.9052C13.6267 20.8891 12.6589 20.8802 10.9865 20.8801L8.40045 20.8799L12.8401 12.0006L17.2798 3.12128L19.9501 3.11458L22.6205 3.10789L22.7405 3.05274C22.8827 2.98736 23.0497 2.83222 23.1161 2.70368C23.1847 2.57077 23.2106 2.37742 23.1816 2.21372C23.1372 1.96282 22.9011 1.69945 22.6608 1.6327C22.6016 1.61624 20.5383 1.60868 16.4045 1.60971C11.1642 1.61103 10.2226 1.61636 10.1444 1.64506Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTextItalic.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextItalic.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextItalic.prototype, "size", void 0);
if (customElements.get('cat-icon-text-italic') === undefined) {
    customElements.define('cat-icon-text-italic', BlocksIconTextItalic);
}
